module.exports = __webpack_public_path__ + "static/img/多媒体显示屏.a0320d4a.png";